import styled, { css } from 'styled-components';
import { heroTitle } from '@stylesheets/helpers';
import { APPS_PHONE_MEDIA } from '../../apps.constants';

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  text-align: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;

export const OrbRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: start;

  ${({ theme: { spacing } }) => css`
    margin-bottom: ${spacing.level4};
  `}
`;

export const Title = styled.h2`
  margin: 0;
  overflow-wrap: anywhere;
  color: ${({ theme: { colors } }) => colors.onSurface};
  ${heroTitle}
`;

export const Subtitle = styled.p`
  margin: 0;
  overflow-wrap: anywhere;

  ${({ theme: { colors, font } }) => css`
    font-size: ${font.bodyLarge.fontSize};
    line-height: ${font.bodyLarge.lineHeight};
    color: ${colors.onSurfaceVariant};

    ${APPS_PHONE_MEDIA} {
      font-size: ${font.bodyMedium.fontSize};
      line-height: ${font.bodyMedium.lineHeight};
    }
  `}
`;
